import React, { memo } from 'react'
import { AuthProvider } from './AuthContext'
import { EmployeeProvider } from './EmployeeContext'
import { DashboardProvider } from './DashboardContext'
import { ManagerProvider } from './ManagerContext'
import { AttendanceProvider } from './AttendanceContext'
import { ManagerEmployeeProvider } from './ManagerEmployeeContext'
import { ManagerAttendanceProvider } from './ManagerAttendanceContext'
import { NotificationProvider } from './NotificationContext'
import { PayrollProvider } from './PayrollContext'
import { BillProvider } from './BillContext'
import { SiteProvider } from './SiteContext'

// Memoized wrapper components to prevent unnecessary re-renders
const MemoizedNotificationProvider = memo(({ children }) => (
  <NotificationProvider>{children}</NotificationProvider>
));

const MemoizedEmployeeProvider = memo(({ children }) => (
  <EmployeeProvider>{children}</EmployeeProvider>
));

const MemoizedDashboardProvider = memo(({ children }) => (
  <DashboardProvider>{children}</DashboardProvider>
));

const MemoizedManagerProvider = memo(({ children }) => (
  <ManagerProvider>{children}</ManagerProvider>
));

const MemoizedAttendanceProvider = memo(({ children }) => (
  <AttendanceProvider>{children}</AttendanceProvider>
));

const MemoizedManagerEmployeeProvider = memo(({ children }) => (
  <ManagerEmployeeProvider>{children}</ManagerEmployeeProvider>
));

const MemoizedManagerAttendanceProvider = memo(({ children }) => (
  <ManagerAttendanceProvider>{children}</ManagerAttendanceProvider>
));

const MemoizedPayrollProvider = memo(({ children }) => (
  <PayrollProvider>{children}</PayrollProvider>
));

const MemoizedBillProvider = memo(({ children }) => (
  <BillProvider>{children}</BillProvider>
));

const MemoizedSiteProvider = memo(({ children }) => (
  <SiteProvider>{children}</SiteProvider>
));

const MainContext = memo(({children}) => {
  return (
   <AuthProvider>
    <MemoizedNotificationProvider>
      <MemoizedEmployeeProvider>
        <MemoizedDashboardProvider>
          <MemoizedManagerProvider>
            <MemoizedAttendanceProvider>
              <MemoizedManagerEmployeeProvider>
                <MemoizedManagerAttendanceProvider>
                  <MemoizedPayrollProvider>
                    <MemoizedBillProvider>
                      <MemoizedSiteProvider>
                        {children}
                      </MemoizedSiteProvider>
                    </MemoizedBillProvider>
                  </MemoizedPayrollProvider>
                </MemoizedManagerAttendanceProvider>
              </MemoizedManagerEmployeeProvider>
            </MemoizedAttendanceProvider>
          </MemoizedManagerProvider>
        </MemoizedDashboardProvider>
      </MemoizedEmployeeProvider>
    </MemoizedNotificationProvider>
   </AuthProvider>
  )
})

export default MainContext